import api from "@/apis/EmbedPaymentDemoMarketingAPI";
import Crud from "./crud-base";

var crud = new Crud("EmbedPaymentDemoMarketing", api);

const state = {
  ...crud.state,
  //...stateOverride,
  _config: {},
  datas: [],
};
const getters = {
  ...crud.getters,
  //...gettersOverride
};
const actions = {
  ...crud.actions,
  //...actionsOverride,
  /**
   *  Load danh sách
   */
  async load(context, payload) {
    let res = null;
    try {
      context.commit("updateLoading", true);
      res = await api.getList(payload || {});
    } finally {
      context.commit("updateLoading", false);
    }

    context.commit("setItems", { result: res, payload: payload });
    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
